import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@davincihealthcare/elty-design-system-react/dist/node_modules/react-calendar/dist/esm/Calendar.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["FaqCard"] */ "/app/src/app/_components/faq/faqCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/layouts/footer/footerWrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/layouts/headerV2/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/widgets/profile/index.tsx");
